/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionInviteOnlineVideosession} from '../../../store/actions/actions-videosession';
import {
  ActionGetUsersPublicList,
  ActionAddUserToContacts,
  ActionStoreServerData,
} from '../../../store/actions/actions-request';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import defaultUser from '../../../assets/images/required/user.png';
import {getUserNameFromString} from '../../../services/common';
import NoResult from '../../NoResult/NoResult';

class ModalVideoSessionInvitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
    };
    this.searchContacts = _.debounce(this.searchContactsData, 700);
    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center add-user-in-video',
      closeButton: true,
      keyboard: true,
    });
  }

  componentDidMount() {
    this.getDefaultContacts();
    this.getUserContacts();
    this.getRecentConctact();
  }

  componentWillUnmount() {
    this.props.ActionStoreServerData('userContacts', []);
    this.props.ActionStoreServerData('usersList', []);
    this.props.ActionStoreServerData('recentContacts', []);
  }

  filterWithOutInvitedUsers = (list = []) => {
    const {streams} = this.props;
    const usersId = streams.map((stream) => {
      const streamUser = stream.user || {};
      if (streamUser.id) return streamUser.id;
    });
    const newList = list.filter((listItem) => {
      if (!usersId.includes(listItem._id)) return listItem;
    });
    return newList;
  };

  getDefaultContacts = (data = {}) => {
    const reqData = {
      perPage: 4,
      ...data,
    };

    this.props.ActionGetUsersPublicList(reqData);
  };

  getUserContacts = (data = {}) => {
    const {isLoggedIn} = this.props;

    if (!isLoggedIn) return null;

    const reqData = {
      perPage: 4,
      filter: {
        isContact: true,
      },
      isContact: true,
      ...data,
    };

    this.props.ActionGetUsersPublicList(reqData, 'userContacts');
  };

  getRecentConctact = (data = {}) => {
    const {isLoggedIn} = this.props;

    if (!isLoggedIn) return null;

    const reqData = {
      perPage: 4,
      filter: {
        isRecentContact: true,
      },
      isRecentContact: true,
      ...data,
    };

    this.props.ActionGetUsersPublicList(reqData, 'recentContacts');
  };

  onCloseClick = () => {
    this.props.ActionModalHide();
  };

  inviteOnVideoSession = (contact) => {
    const {sessionId, stream} = this.props;
    const data = {
      userId: contact._id,
      sessionId,
    };

    this.props.ActionInviteOnlineVideosession(data, contact, stream);
    this.props.ActionModalHide();
  };

  addToContactsListCallback = () => {
    this.searchContactsData();
  };

  onAddToContactList = (userId) => {
    this.props.ActionAddUserToContacts(userId, this.addToContactsListCallback);
  };

  renderContactList = (contactList) => {
    const {isLoggedIn, user} = this.props;

    return contactList.map((contact, index) => {
      if (contact._id === user._id) return null;

      return (
        <div className="contact-item" key={index}>
          <div className="user-image">
            <img src={contact.photoUrl || defaultUser} alt="user name" />
          </div>
          <div className="contact-info">
            <div className="contact-name">{getUserNameFromString(contact.name, true)}</div>
          </div>
          <div className="btn-wrap">
            {isLoggedIn && !contact.isContact
            && (
              <button
                className="btn-icon btn-icon-conture-bl add-user"
                title="Добавить в контакты"
                onClick={() => this.onAddToContactList(contact._id)}
              />
            )}
            <button
              className="btn btn-base"
              title="Пригласить на видеосессию"
              onClick={() => this.inviteOnVideoSession(contact)}
            >
              Пригласить
            </button>
          </div>
        </div>
      );
    });
  };

  renderMnjConctactList = (usersList) => {
    const sortedContactsList = _.sortBy(usersList, ['name']);

    if (!sortedContactsList.length) return null;

    return (
      <div className="contact-list-wrap">
        <div className="contact-title">
          <h3 className="contact-title-text">Справочник My new job</h3>
        </div>
        <div className="contact-list">
          {this.renderContactList(sortedContactsList)}
        </div>
      </div>
    );
  };

  renderConctactList = (userContacts) => {
    const sortedContactsList = _.sortBy(userContacts, ['name']);
    const filteredContactsList = _.filter(sortedContactsList, {isContact: true});
    if (!filteredContactsList.length) return null;

    return (
      <div className="contact-list-wrap">
        <div className="contact-title">
          <h3 className="contact-title-text">Контакты</h3>
        </div>
        <div className="contact-list">
          {this.renderContactList(filteredContactsList)}
        </div>
      </div>
    );
  };

  renderRecentConctactList = (recentContacts) => {
    if (!recentContacts.length) return null;

    return (
      <div className="contact-list-wrap">
        <div className="contact-title">
          <h3 className="contact-title-text">Недавние</h3>
        </div>
        <div className="contact-list">
          {this.renderContactList(recentContacts)}
        </div>
      </div>
    );
  };

  onChangeSearchInput = (e) => {
    this.setState({
      searchInput: e.target.value,
    }, () => {
      if (this.state.searchInput.length >= 3) {
        this.searchContacts();
      } else {
        this.getDefaultContacts();
        this.getUserContacts();
        this.getRecentConctact();
      }
    });
  };

  searchContactsData = () => {
    const {searchInput} = this.state;
    const searchData = {
      perPage: 100,
      q: searchInput,
    };

    this.getDefaultContacts(searchInput ? searchData : {});
    this.getUserContacts(searchInput ? searchData : {});
    this.getRecentConctact(searchInput ? searchData : {});
  };

  render() {
    const {searchInput} = this.state;
    const {
      userContacts, usersList, recentContacts, usersListLoading,
    } = this.props;
    const filteredUserContacts = this.filterWithOutInvitedUsers(userContacts);
    const filteredUsersList = this.filterWithOutInvitedUsers(usersList);
    const filteredRecentList = this.filterWithOutInvitedUsers(recentContacts);

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-header">
            <h3 className="modal-header_title">Пригласить на видеосессию</h3>
            <button className="modal-close-btn" onClick={this.onCloseClick}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal-content">
            <div className="search-input">
              <div className="contact-search">
                <button className="contact-search-btn" />
                <input
                  type="text"
                  placeholder="Введите имя"
                  className="contact-search-input"
                  onChange={this.onChangeSearchInput}
                  value={searchInput}
                />
              </div>
            </div>
            <div className="contact-wrap">
              <div className="contact-inner custom-scroll-small">
                {this.renderRecentConctactList(filteredRecentList)}
                {this.renderConctactList(filteredUserContacts)}
                {this.renderMnjConctactList(filteredUsersList)}
                {!usersList.length && !userContacts.length && usersListLoading
                  && <h1 className="loading-text">Загрузка...</h1>}
                {!filteredUserContacts.length && !filteredUsersList.length && !usersListLoading && <NoResult />}
              </div>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalVideoSessionInvitation.defaultProps = {
  usersList: [],
  userContacts: [],
  recentContacts: [],
  streams: [],
};

ModalVideoSessionInvitation.propTypes = {};

function mapStateToProps({
  rServerData, rUser, rSession, rLoading, rVideoSession,
}) {
  return {
    usersList: rServerData.usersList,
    user: rUser,
    userContacts: rServerData.userContacts,
    recentContacts: rServerData.recentContacts,
    isLoggedIn: rSession.LOGGED_IN,
    usersListLoading: rLoading.usersListLoading,
    streams: rVideoSession.streams,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionInviteOnlineVideosession,
    ActionGetUsersPublicList,
    ActionAddUserToContacts,
    ActionStoreServerData,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalVideoSessionInvitation);
